import { memo } from 'react';
import SlotMachineScreen from '../../Components/SlotMachine';
import { useAppSelector } from '../../store';
import AviatorWrapper from '../../Components/AviatorWrapper';
import { IAviatorStore } from '../../types';

const HomePage = memo(() => {
  const { activeGame } = useAppSelector(
    ({ aviator }) => aviator,
  );
  const displaySlotGameStatuses: IAviatorStore['activeGame'][] = ['slotMachine', 'transition-stage'];
  return (
    <div>
      <div className={displaySlotGameStatuses.includes(activeGame) ? undefined : 'hidden'}>
        <SlotMachineScreen />
      </div>
      <div className={activeGame !== 'aviator' ? 'hidden' : undefined}>
        <AviatorWrapper />
      </div>
    </div>
  );
});

HomePage.displayName = 'HomePage';

export default HomePage;
